import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import UserProfile from "../screens/Users1/UserProfile";

const breadCrumbData = [
  { link: "/users-view", name: "Users" },
  { link: "/userdetails", name: "User Details" }
];

const Users = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <UserProfile />
    </LayoutContainer>
  </>
);

export default Users;
